import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RoleResponse } from '@app/interface/role';

@Injectable({
  providedIn: 'root',
})
export class CommunicationBetweenComponentsService {
  public rechargeAchivementsObservable = new Subject<boolean>();
  public rechargeSeniorityObservable = new Subject<boolean>();
  public enabledAssessment: boolean | undefined;
  private globalRole!: RoleResponse;

  constructor() {
    this.enabledAssessment = undefined;
  }

  public setRole(role: RoleResponse) {
    this.globalRole = role;
  }

  public getRole(): RoleResponse {
    return this.globalRole;
  }

  public validateRole(userRoles: RoleResponse, validateRole: number) {
    if (!userRoles?.role) {
      return false;
    }

    return userRoles.role.some(role => role.id === validateRole);
  }

  public setEnabledAssessment(enabledAssessment: boolean | undefined) {
    this.enabledAssessment = enabledAssessment;
  }

  public getEnabledAssessment(): boolean | undefined {
    return this.enabledAssessment;
  }
}
